import { table } from "../models.model";

export const VOLATILIDAD_AIRAC: table = {
  columnas: [
    'Rango de plazo',
    '0-15 días',
    '0-30 días',
    '0-60 días',
    '0-90 días',
  ],
  filas: [
    {
      type: 'valorComp',
      id: 'DESVIACION',
      codigo: '',
      valorComparar: 'desviacion',
      bandas: [1,1,1,1],
      descripcion: 'Desviación estandar',
      decimales: 6,
      visible: true,
    },{
      type: 'operacion',
      id: 'OPERACION',
      bandas: [1,1,1,1],
      decimales: 6,
      descripcion: 'Fluctuación esperada | D.E * _',
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'cuenta', valor: 'DESVIACION'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 2}
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'cuenta', valor: 'DESVIACION'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 2}
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'cuenta', valor: 'DESVIACION'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 2}
          ]
        },{
          banda: 3,
          expresion: [
            {tipo: 'cuenta', valor: 'DESVIACION'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 2}
          ]
        }
      ],
      visible: true,
    },{
      type: 'valorComp',
      id: 'DESVIACION_CUENTAS',
      codigo: '',
      valorComparar: 'desviacioncuentas',
      bandas: [1,1,1,1],
      descripcion: 'Número de variaciones logarítmicas',
      decimales: 0,
      visible: true,
    },{
      type: 'operacion',
      id: 'OPERACION',
      bandas: [1,1,1,1],
      decimales: 0,
      descripcion: 'Porción volatil de los depósitos',
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'numeroUsuario'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'cuenta', valor: 'DESVIACION_CUENTAS'}
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'numeroUsuario'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'cuenta', valor: 'DESVIACION_CUENTAS'}
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'numeroUsuario'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'cuenta', valor: 'DESVIACION_CUENTAS'}
          ]
        },{
          banda: 3,
          expresion: [
            {tipo: 'numeroUsuario'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'cuenta', valor: 'DESVIACION_CUENTAS'}
          ]
        }
      ],
      visible: true,
    }
  ]
}